import { attr, belongsTo, hasMany } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  headline: attr('string'),
  isProduced: attr('boolean'),
  productionLink: attr('string'),
  summary: attr('string'),
  characters: attr('string'),
  applicationId: attr('string'),

  //relationships
  application: belongsTo('application', { async: false }),
  image: belongsTo('image', { async: false }),
  location: belongsTo('location', { async: false }),
  weburls: hasMany('weburl', { async: false }),
});
